<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed, nextTick } from "vue";
import { useEchartStore } from '@/stores/echartStore'
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
const echartStore = useEchartStore()
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow, (val) => {
  if (val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute.hideCompInTabw, (val) => {
  if (!val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute, (obj) => {
  console.log(obj,'objobjobj');
  if (obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {}
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        console.log(dataKey, 'dataKey')
        let newarr = [];
        const fieldMap = dataKey.reduce((acc, curr) => {
          acc[curr.namekey] = curr.value;
          return acc;
        }, {});

        // 遍历原始数组并构建映射和新数组
        const groupMap = {};
        res.forEach(item => {
          const groupKey = item[fieldMap.group];
          if (!groupMap[groupKey]) {
            groupMap[groupKey] = {
              group: item[fieldMap.group],
              unit: item[fieldMap.unit],
              type: item[fieldMap.type],
              data: []
            };
          }

          // 构建data部分
          groupMap[groupKey].data.push({
            name: item[fieldMap.name],
            value: item[fieldMap.value]
          });
        });

        // 将映射转换为最终数组
        newarr = Object.values(groupMap);
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attribute) {
  if (!cptData) return;
  const attr = JSON.parse(JSON.stringify(attribute));
  let xAisData = [];
  cptData[0].data.forEach(item => {
    xAisData.push(item.name)
  })
  chartOption = {
    color: attr.color,
    title: attr.title,
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      ...attr.tooltip
    },
    grid: attr.grid,
    legend: attr.legend,
    xAxis: {
      axisLabel: {
        textStyle: {
          fontFamily: attr.xAxis.axisLabel.fontFamily
        }
      },
      ...attr.xAxis,

    },
    dataZoom: attr.dataZoom,
  }
  chartOption.xAxis.data = xAisData
  let yAxis = []
  let series = []
  let seriesLabel = attr.series.label;

  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i]
    seriesLabel = {
      ...attr.series.label,
      formatter: attr.series.label.unit ? '{c}' + (item.unit || '') : null
    }
    console.log(attr.yAxis,'attribute.yAxisShows');
    // 通过配置隐藏那些y轴的显示属性
    let yAxisShow = attr.yAxis?.yAxisShows && attr.yAxis?.yAxisShows?.includes(item.group) ? false : true
    let yAxisLabelColor = attr.yAxis.axisLabel.yColors && attr.yAxis.axisLabel.yColors[i]
    yAxis.push({
      type: 'value',
      name: item.group,
      position: i === 0 ? 'left' : 'right',
      alignTicks: true,
      offset: i > 0 ? (i - 1) * 80 : 0,
      show: yAxisShow, 
      nameTextStyle: {
        fontFamily: attr.yAxis.axisLabel.fontFamily
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: yAxisLabelColor ? yAxisLabelColor : attr.color[i] || '#f00',
        }
      },
      splitLine: attr.yAxis.splitLine,
      axisLabel: {
        formatter: '{value}' + (item.unit || ''),
        fontSize: attr.yAxis.axisLabel.fontSize,
        rotate: attr.yAxis.axisLabel.rotate,
        textStyle: {
          fontFamily: attr.yAxis.axisLabel.fontFamily
        }
      }
    })
    let data = []
    item.data.forEach(column => {
      data[xAisData.indexOf(column.name)] = column.value
    })
    series.push({
      name: item.group,
      type: item.type || 'bar',
      yAxisIndex: i,
      data: data,
      smooth: attr.series.smooth,
      showBackground: attr.series.showBackground,
      label: seriesLabel,
      barWidth: attr.series.barWidth,
      tooltip: {
        valueFormatter: function (value) {
          return value + (item.unit || '');
        }
      },
    })
  }
  chartOption.yAxis = yAxis;
  chartOption.series = series;
  console.log(chartOption, 'jdqwidjwqjidqwij');
  echartStore.setOptions(props.current.id, chartOption)
  // props.option.attribute.yAxisShows = yAxis.map(item => item.name)

  chart.setOption(chartOption, true);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
